exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone{border-radius:8px;border-width:1px;border-style:dashed}.dz-progress{display:none}", ""]);

// exports
